import { HTTPClient } from "./Client";

const PessoaTurmaApi = {

    async deletarPessoaTurmaAsync(pessoaId) {
        await HTTPClient.put(`/PessoaTurma/DeletarPessoaTurma/${pessoaId}`);
    },

    async adicionarPessoasTurmaAsync(turmaId, pessoasId) {
        const response = await HTTPClient.post(`/PessoaTurma/AdicionarPessoaTurma`, {
            turmaId: turmaId,
            pessoasId: pessoasId
        });
        return response.data;
    },

    async listarPessoasSemTurmaAsync() {
        const response = await HTTPClient.get(`/Pessoa/ListarPessoasSemTurma`);
        return response.data;
    },

    async listarMonitoresSemTurmaEspecificaAsync(turmaId) {
        const response = await HTTPClient.get(`/PessoaTurma/ListarMonitoresSemTurmaEspecifica/${turmaId}`);
        return response.data;
    },

    async listarTodasPessoasAsync() {
        const response = await HTTPClient.get(`/Pessoa/ListarPessoas`);
        return response.data;
    },

    async listarTurmasPorPessoaAsync() {
        const response = await HTTPClient.get(`/PessoaTurma/ListarTurmaPorPessoa`);
        return response.data;
    }
}

export default PessoaTurmaApi;